export const RECEIVE_URL_INTEGRATION_SUCCESS = "RECEIVE_URL_INTEGRATION_SUCCESS"
export const CHECK_AUTHORIZE_STRIPE = "CHECK_AUTHORIZE_STRIPE"
export const RECEIVE_URL_INTEGRATION_ERROR = "RECEIVE_URL_INTEGRATION_ERROR"
export const ADMIN_DELETE_USER_DONATION = "ADMIN_DELETE_USER_DONATION"
export const ADMIN_DELETE_CONSTITUENT_DONATION = "ADMIN_DELETE_CONSTITUENT_DONATION"
export const ADMIN_ADD_USER_DONATION = "ADMIN_ADD_USER_DONATION"
export const ADMIN_ADD_CONSTITUENT_DONATION = "ADMIN_ADD_CONSTITUENT_DONATION"
export const ADMIN_EDIT_USER_DONATION = "ADMIN_EDIT_USER_DONATION"
export const ADMIN_EDIT_CONSTITUENT_DONATION = "ADMIN_EDIT_CONSTITUENT_DONATION"

export const checkAuthorizeStripe = (ticketId) => ({
  type: CHECK_AUTHORIZE_STRIPE,
  ticketId,
})

export const receiveUrlIntegrationSuccess = (url) => ({
  type: RECEIVE_URL_INTEGRATION_SUCCESS,
  url,
})

export const receiveUrlIntegrationError = (error) => ({
  type: RECEIVE_URL_INTEGRATION_ERROR,
  error,
})

export const adminDeleteUserDonation = (donationId, error) => ({
  type: ADMIN_DELETE_USER_DONATION,
  donationId,
  error,
})

export const adminEditUserDonation = (params, donationId, success, error) => ({
  type: ADMIN_EDIT_USER_DONATION,
  params,
  donationId,
  success,
  error,
})

export const adminEditConstituentDonation = (
  params,
  constituentId,
  donationId,
  success,
  error,
) => ({
  type: ADMIN_EDIT_CONSTITUENT_DONATION,
  params,
  constituentId,
  donationId,
  success,
  error,
})

export const adminDeleteConstituentDonation = (constituentId, donationId, error) => ({
  type: ADMIN_DELETE_CONSTITUENT_DONATION,
  constituentId,
  donationId,
  error,
})

export const adminAddUserDonation = (donationAmount, donationDate, success, error) => ({
  type: ADMIN_ADD_USER_DONATION,
  donationAmount,
  donationDate,
  success,
  error,
})

export const adminAddConstituentDonation = (
  constituentId,
  donationAmount,
  donationDate,
  success,
  error,
) => ({
  type: ADMIN_ADD_CONSTITUENT_DONATION,
  constituentId,
  donationAmount,
  donationDate,
  success,
  error,
})
